import { ImportButton } from '@components/Buttons/ImportButton';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useData } from '@hooks/useData';
import { useEffectOnce } from '@hooks/useEffectOnce';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import { useMenu } from '@hooks/useMenu';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { EnumSortDirection } from '@hooks/useRequest';
import { EnumEmpresa, useEmpresaCombo } from '@model/Empresa';
import { IRetorno } from '@model/Retorno';
import { IRetornoFilter, useRetornoService } from '@services/RetornoService';
import React from 'react';
import { RetornoFilter } from './RetornoFilter';
import { RetornoImportarModal } from './RetornoImportarModal';
import { RetornoMenu } from './RetornoMenu';
import { RetornoTable } from './RetornoTable';

export type RetornoProps = {

}

export function Retorno (props: RetornoProps) {
    const loading = useLoading();
    const message = useMessage();

    const retornoService = useRetornoService();
    const empresaCombo = useEmpresaCombo();
    const menu = useMenu();
    const importarModal = useModalWindow();

    const data = useData<IRetorno, IRetornoFilter>({
        filter: {
            empresaId: useField(EnumEmpresa.None),
            numero: useField()
        },

        sortField: {
            name: "retornoId",
            direction: EnumSortDirection.Desc
        }
    });

    React.useEffect(() => {
        if (!loading.isLoading) {
            loading.start();
            retornoService.listar(data.requestedData)
                .then(data.handleResultResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    useEffectOnce(() => {
        empresaCombo.loadOptions();
    })

    return (
        <Main>
            <PageTitle>
                <HorizontalGrid>
                    <GridItem>
                        <PageTitleText text="Retornos" />
                    </GridItem>
                    <GridItem floatRight>
                        <ImportButton onClick={importarModal.open} />
                    </GridItem>
                </HorizontalGrid>

                
            </PageTitle>
            
            <PageContent>
                <RetornoFilter 
                    filter={data.filter}
                    isLoading={loading.isLoading}
                    empresaCombo={empresaCombo}
                />

                <TableWrapper>
                    <RetornoTable 
                        data={data}
                        isLoading={loading.isLoading}
                        menu={menu}
                    />
                </TableWrapper>

                <RetornoImportarModal 
                    modal={importarModal}
                />

                {
                    data.focusedRow !== undefined && (
                        <React.Fragment>
                            <RetornoMenu 
                                retorno={data.focusedRow}
                                menu={menu}
                            />
                        </React.Fragment>
                    )
                }
            </PageContent>
        </Main>
    )
}